import React from "react";
import pic1 from "../assetsWeb/images/header-img.png";
import pic2 from "../assetsWeb/images/prod-1.png";
import pic3 from "../assetsWeb/images/prod-2.png";
import pic4 from "../assetsWeb/images/prod-3.png";
import pic5 from "../assetsWeb/images/prod-4.png";

import d111 from "../assetsWeb/images/d111.png";
import d112 from "../assetsWeb/images/d112.png";
import d113 from "../assetsWeb/images/d113.png";
import d114 from "../assetsWeb/images/d114.png";
import d115 from "../assetsWeb/images/d115.png";
import d116 from "../assetsWeb/images/d116.png";

import e111 from "../assetsWeb/images/blog-1.png";
import e112 from "../assetsWeb/images/blog-2.png";
import e113 from "../assetsWeb/images/career.png";

import googlee from "../assetsWeb/images/Google_Play_Store_badge_EN.png";
import applee from "../assetsWeb/images/Download_on_the_App_Store_RGB_blk.png";

import food from "../assetsWeb/images/categ-1.png";
import fipackage from "../assetsWeb/images/categ-2.png";
import fipharmacy from "../assetsWeb/images/categ-3.png";
import shops from "../assetsWeb/images/categ-4.png";
import groceries from "../assetsWeb/images/categ-5.png";
import bargain from "../assetsWeb/images/categ-6.png";

import { FaRegCircleUser } from "react-icons/fa6";
import { CiLocationArrow1, CiLocationOn } from "react-icons/ci";
import logo from "../assetsWeb/images/header-logo.png";
import { Link } from "react-router-dom";
const HomePage = () => {
  return (
    <>
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <a className="navbar-brand" href="index.html">
          <img src={logo} alt="Logo" id="logsedf" style={{ width: "52%" }} />
        </a>
        <Link
          to="/login"
          className="button-21"
          role="button"
          style={{ marginRight: "45px" }}
        >
          <span className="icon-user">
            <FaRegCircleUser />
          </span>{" "}
          &nbsp;Login
        </Link>
      </header>

      <div className="hero">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={pic1}
            alt="Delivery"
            className="left-image"
            style={{ height: "300px" }}
          />
          <div className="slogan">
            <p style={{ fontWeight: "600", fontSize: "xx-large" }}>
              One Solution for Every Delivery!
            </p>
            <div className="address-input-wrapper">
              <div style={{ position: "relative", width: "100%" }}>
                <CiLocationOn
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "20px",
                    color: "#888",
                  }}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input type="text" placeholder=" What's your address?" />
              </div>
              <div>
                <button className="location-button">
                  <CiLocationArrow1 />
                  &nbsp;Current Location
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="categories">
        <div>
          <img src={food} alt="Food" />
          <p>Food</p>
        </div>
        <div>
          <img src={fipackage} alt="Package Delivery" />
          <p>Package Delivery</p>
        </div>
        <div>
          <img src={fipharmacy} alt="Pharmacy & Beauty" />
          <p>Pharmacy & Beauty</p>
        </div>
        <div>
          <img src={shops} alt="Shops" />
          <p>Shops</p>
        </div>
        <div>
          <img src={groceries} alt="Groceries" />
          <p>Groceries</p>
        </div>
        <div>
          <img src={bargain} alt="Drovi Bargains" />
          <p>Drovi Bargains</p>
        </div>
      </div>

      <div className="store-section">
        <h1>Shops You Might Like</h1>
        <br />
        <div className="store-grid">
          <div className="store">
            <img src={pic2} alt="Store Image" />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 style={{ color: "#00A699" }}>KFCC</h3>
              <div style={{ alignContent: "center", margin: "10px" }}>
                96%(500+)
              </div>
            </div>
          </div>
          <div className="store">
            <img src={pic3} alt="Store Image" />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 style={{ color: "#00A699" }}>Chicken Inn</h3>
              <div style={{ alignContent: "center", margin: "10px" }}>
                96%(500+)
              </div>
            </div>
          </div>
          <div className="store">
            <img src={pic4} alt="Store Image" />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 style={{ color: "#00A699" }}>Galito's</h3>
              <div style={{ alignContent: "center", margin: "10px" }}>
                96%(500+)
              </div>
            </div>
          </div>
          <div className="store">
            <img src={pic5} alt="Store Image" />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 style={{ color: "#00A699" }}>Drovi Bargains</h3>
              <div style={{ alignContent: "center", margin: "10px" }}>
                96%(500+)
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="categories-section">
        <h2>Top Categories in Nairobi</h2>
        <div className="categories-container">
          <div className="category-item">
            <img src={d111} alt="Chicken" />
            <span className="category-tag">Chicken</span>
          </div>
          <div className="category-item">
            <img src={d112} alt="Burger" />
            <span className="category-tag">Burger</span>
          </div>
          <div className="category-item">
            <img src={d113} alt="Fast Food" />
            <span className="category-tag">Fast Food</span>
          </div>
          <div className="category-item">
            <img src={d114} alt="Pizza" />
            <span className="category-tag">Pizza</span>
          </div>
          <div className="category-item">
            <img src={d115} alt="Desserts" />
            <span className="category-tag">Desserts</span>
          </div>
          <div className="category-item">
            <img src={d116} alt="Pasta" />
            <span className="category-tag">Pasta</span>
          </div>
        </div>
      </section>

      <section className="together-section">
        <h2>Let’s do it together</h2>
        <div className="together-container">
          <div className="together-item">
            <div className="image-container">
              <img src={e111} alt="Become a rider" />
            </div>
            <div className="text-container">
              <h3>Become a rider</h3>
              <p>
                Enjoy flexibility, freedom, and competitive earnings by
                delivering through Drovi.
              </p>
            </div>
            <div className="button-container">
              <button>Register Here</button>
            </div>
          </div>
          <div className="together-item">
            <div className="image-container">
              <img src={e112} alt="Become a rider" />
            </div>
            <div className="text-container">
              <h3>Become a partner</h3>
              <p>
                Grow with Drovi! Our technology and user base can help you boost
                sales and unlock new opportunities!
              </p>
            </div>
            <div className="button-container">
              <button>Register Here</button>
            </div>
          </div>
          <div className="together-item">
            <div className="image-container">
              <img src={e113} alt="Become a rider" />
            </div>
            <div className="text-container">
              <h3>Careers</h3>
              <p>
                Ready for an exciting new challenge? If you’re ambitious,
                humble, and love working with others, we want to hear from you!
              </p>
            </div>
            <div className="button-container">
              <button>Register Here</button>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <h3
          style={{
            display: "flex",
            justifyContent: "left",
            fontSize: "37px",
            color: "#28B8EC",
          }}
        >
          Drovi
        </h3>
        <div className="footer-container">
          <div className="footer-column">
            <h3>Let’s do it together</h3>
            <ul>
              <li>
                <a href="#">Career</a>
              </li>
              <li>
                <a href="#">Partner</a>
              </li>
              <li>
                <a href="#">Couriers</a>
              </li>
              <li>
                <a href="#">Business</a>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Link of Interest</h3>
            <ul>
              <li>
                <a href="#">About Us</a>
              </li>
              <li>
                <a href="#">FAQs</a>
              </li>
              <li>
                <a href="#">Drovi Prime</a>
              </li>
              <li>
                <a href="#">Blog</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
              <li>
                <a href="#">Security</a>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Follow us</h3>
            <ul>
              <li>
                <a href="#">Facebook</a>
              </li>
              <li>
                <a href="#">Twitter</a>
              </li>
              <li>
                <a href="#">Instagram</a>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <div className="app-icons">
              <a href="#">
                <img src={googlee} alt="Google Play" />
              </a>
              <a href="#">
                <img src={applee} alt="App Store" />
              </a>
              <ul>
                <li>
                  <a href="#">Facebook</a>
                </li>
                <li>
                  <a href="#">Twitter</a>
                </li>
                <li>
                  <a href="#">Instagram</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>All Rights Reserved. Iconictek Company © 2022</p>
        </div>
      </footer>
    </>
  );
};

export default HomePage;
